import { IconProps } from "@/common/contracts/icon.contracts";

export const TagOutlined = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3890_10592)">
        <path
          d="M20.469 12.0246L12.369 3.92459C12.0315 3.58986 11.5753 3.40221 11.1 3.40259H4.8C4.32261 3.40259 3.86477 3.59223 3.52721 3.9298C3.18964 4.26736 3 4.7252 3 5.20259V11.5026C2.99981 11.7401 3.04664 11.9753 3.13777 12.1947C3.2289 12.414 3.36255 12.6131 3.531 12.7806L11.631 20.8806C11.9685 21.2153 12.4247 21.403 12.9 21.4026C13.3766 21.4006 13.833 21.2096 14.169 20.8716L20.469 14.5716C20.807 14.2356 20.998 13.7792 21 13.3026C21.0002 13.0651 20.9534 12.8299 20.8622 12.6105C20.7711 12.3912 20.6374 12.192 20.469 12.0246ZM12.9 19.6026L4.8 11.5026V5.20259H11.1L19.2 13.3026M7.05 6.10259C7.317 6.10259 7.57801 6.18176 7.80002 6.3301C8.02203 6.47844 8.19506 6.68929 8.29724 6.93597C8.39942 7.18265 8.42615 7.45409 8.37406 7.71596C8.32197 7.97783 8.1934 8.21838 8.00459 8.40718C7.81579 8.59598 7.57525 8.72456 7.31337 8.77665C7.0515 8.82874 6.78006 8.802 6.53338 8.69983C6.2867 8.59765 6.07586 8.42461 5.92752 8.20261C5.77918 7.9806 5.7 7.71959 5.7 7.45259C5.7 7.09455 5.84223 6.75117 6.09541 6.49799C6.34858 6.24482 6.69196 6.10259 7.05 6.10259Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3890_10592">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.402588)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
